<template>
<footer class="footer">
  <div class="footer-container">
    <p class="footer-note">{{ disclaimer }}</p>
    <nav class="footer-links" aria-label="Footer">
      <a v-for="link in footerNav" :key="link.path" :href="link.path" class="footer-link">{{ link.label }}</a>
    </nav>
    <p class="footer-copy">&copy; {{ year }} {{ siteDomain }}. All rights reserved.</p>
  </div>
</footer>
</template>

<script>
import { footerNav, footerDisclaimer } from '@/data/siteNav'
import { SITE_DOMAIN } from '@/config/site'

export default {
  name: 'Footer',
  data() {
    return {
      footerNav,
      disclaimer: footerDisclaimer,
      siteDomain: SITE_DOMAIN,
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #0b2136;
  color: #c7d5e3;
  padding: 22px 0 20px;
  border-top: 3px solid #128c7e;
}

.footer-container {
  box-sizing: border-box;
  width: 100%;
  max-width: var(--content-max, 1120px);
  padding: 0 var(--content-pad, 24px);
  margin: 0 auto;
  text-align: center;
}

.footer-note {
  margin: 0 0 12px;
  font-size: 0.875rem;
  line-height: 1.55;
  color: #b8c9d9;
  max-width: 52rem;
  margin-left: auto;
  margin-right: auto;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 16px;
  margin-bottom: 10px;
}

.footer-link {
  color: #fff;
  text-decoration: none;
  font-size: 0.9375rem;

  &:hover {
    color: #55efc4;
  }
}

.footer-copy {
  margin: 0;
  font-size: 0.8125rem;
  opacity: 0.85;
}
</style>
